import React, { useState } from "react";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import CustomJS from "../../../../components/BuilderComponents/CustomJS";
import { NewPrefilter } from "../../../../components/BuilderComponents/PreFilters/PreFilter";
import Button from "../../../../components/FormComponents/Button";
import Input from "../../../../components/FormComponents/Input";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAxiosContext } from "../../../../context/AxiosContext";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import { HiddenColumns } from "../../RecordsViewRenderer/Mobile/MobileRecordEditSection";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../../utils/objectIdUtils";

const DetailviewHeader = ({ device, activityID = "", allowEdit, setAllowEdit, headerComponent, flag = true }) => {
  return (
    <div className={`detailsView_items_top px_3 ${device === "mobile" ? "mobile_style" : ""}`}>
      {headerComponent}
      {activityID && (
        <div className={`detailsView_activity_top ${device === "desktop" ? "w_50" : ""}`}>
          <div className="detailsView_activity_top_items w_100 ">
            {device === "desktop" && (
              <label className="prefilter_checkbox_label builder_label mb_0">{/* Place Holder */}</label>
            )}
          </div>
        </div>
      )}
      <div className="detailsView_toggle_outer" style={{ marginLeft: device === "mobile" ? "auto" : "" }}>
        <DetailviewLayoutAction isEdit={allowEdit} onChangeEdit={() => setAllowEdit(!allowEdit)} flag={flag} />
      </div>
    </div>
  );
};

const DetailviewLayoutAction = ({ isEdit, onChangeEdit, flag }) => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  return (
    <div className="detailsView_activity_top_items">
      {flag && (
        <>
          <label>Export as Template</label>
          <MaterialIcon
            name="upgrade"
            className="screen_top_icons"
            title="Export As Template"
            onClick={() => setIsExportModalOpen(true)}
          />
        </>
      )}
      <span className="edit_mode_label">Edit Mode</span>
      <div className={`toggle_switch ${isEdit ? "active" : ""}`} onClick={onChangeEdit}>
        <div className="toggle_slider"></div>
      </div>
      <BuilderModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        modalName={"Export As Template"}
      >
        <ExportAsTemplateModal closeModal={() => setIsExportModalOpen(false)} />
      </BuilderModal>
    </div>
  );
};

const ExportAsTemplateModal = ({ closeModal }) => {
  const [templateName, setTemplateName] = useState("");
  const { axiosInstance, handleSuccess, handleError } = useAxiosContext();
  const { getDetailviewConfig } = useAppBlocksContext();
  const [file, setFile] = useState(null);

  const handleSave = async () => {
    try {
      const { unique_ids, elements } = getDetailviewConfig(true);
      const image_data = await addImage();
      const payload = {
        config: {
          elements,
          unique_ids,
          image_data
        },
        name: templateName,
        type: "detailsview"
      };

      const response = await axiosInstance.post("/sysconfigs", payload);
      const { message } = response.data;
      handleSuccess(message);
      closeModal();
    } catch (error) {
      handleError(error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  const addImage = async () => {
    try {
      const formData = new FormData();
      formData.append("myFile", file);

      const uploadResponse = await axiosInstance.post(`/public/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const { name, original_name, type, _id } = uploadResponse.data;
      const modifiedImage = { image_id: _id, name, original_name, type };
      setFile(null);

      return modifiedImage;
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="builder_form">
      <Input
        label="Enter Template Name"
        placeholder="Enter Template Name"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
      />
      <Input label="Add Image" type="file" name="image_data" onChange={handleFileChange} />

      <Button onClick={handleSave}>Save</Button>
    </div>
  );
};

const DetailviewEditActions = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeRightbar = () => {
    setIsOpen({
      show: false,
      type: ""
    });
  };

  return (
    <>
      <div className="d_flex gap_2 align_center">
        <Button
          variant="secondary"
          size="small"
          onClick={() =>
            setIsOpen({
              show: true,
              type: "edit",
              title: "Edit"
            })
          }
        >
          Edit
        </Button>
      </div>
      <BuilderRightSideBar isOpen={isOpen.show} onClose={closeRightbar} heading={isOpen.title} size="large">
        <DetailsviewGeneralEdit />
      </BuilderRightSideBar>
    </>
  );
};

const DetailsviewGeneralEdit = () => {
  const { setApplicationBlockData, applicationBlockData } = useAppBlocksContext();

  const handleChangePrefilters = (newPrefilter) => {
    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        pre_filters: newPrefilter.prefilter,
        prefilters_joined_by: newPrefilter.prefilters_joined_by
      }
    });
  };

  const handleChangeVariables = (newVariables) => {
    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        variables: newVariables
      }
    });
  };

  const handleChangeHiddenFields = (newHiddenFields) => {
    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        hidden_fields: newHiddenFields
      }
    });
  };

  const tabsData = [
    {
      label: "Variables",
      content: (
        <div className="p_4" style={{ minWidth: "650px" }}>
          <DetailviewVariables
            variables={applicationBlockData.data.variables || []}
            onChangeVariables={handleChangeVariables}
            tableId={applicationBlockData.data.table_id}
          />
        </div>
      )
    },
    {
      label: "Prefilters",
      content: (
        <div className="p_3">
          <NewPrefilter
            prefiltersWithFormula={{
              prefilters_joined_by: applicationBlockData?.data?.prefilters_joined_by || "",
              prefilter: applicationBlockData?.data?.pre_filters || []
            }}
            handleChange={handleChangePrefilters}
            tableId={applicationBlockData?.data?.table_id}
            tableType={applicationBlockData.table_type}
          />
        </div>
      )
    },
    {
      label: "Hidden Fields",
      content: (
        <div className="p_3">
          <HiddenColumns
            columns={applicationBlockData.data.hidden_fields || []}
            handleChange={handleChangeHiddenFields}
            tableId={applicationBlockData?.data?.table_id}
            label="Hidden Fields"
          />
        </div>
      )
    }
  ];

  return <BuilderTabs tabs={tabsData} />;
};

const DetailviewVariables = ({ variables, onChangeVariables, tableId }) => {
  const [variableName, setVariableName] = useState("");
  const [selectedVariable, setSelectedVariable] = useState(0);

  const addVariable = () => {
    const newVariableName = variableName.trim();
    if (!newVariableName) {
      return;
    }
    const variableObject = {
      display: newVariableName,
      id: generateObjectId(),
      custom_js: "",
      type: "variable"
    };
    onChangeVariables([...variables, variableObject]);
    setVariableName("");
  };

  const deleteVariable = (e, index) => {
    e.stopPropagation();
    const newVariables = [...variables];
    newVariables.splice(index, 1);
    onChangeVariables(newVariables);
    if (index === selectedVariable) {
      setSelectedVariable(0);
    }
  };

  const handleChangeInCustomJS = (value) => {
    const newVariables = [...variables];
    newVariables[selectedVariable].custom_js = value;
    onChangeVariables(newVariables);
  };
  return (
    <>
      <div className="builder_form mb_3">
        <Input
          label="Enter Variable Name"
          placeholder="Enter Variable Name"
          value={variableName}
          onChange={(e) => setVariableName(e.target.value)}
        />
        <div className="w_100">
          <Button variant="secondary" onClick={addVariable}>
            Add Variable
          </Button>
        </div>
      </div>
      <div className="detailsView_variable_outer">
        <div className="variable_block_left">
          {variables.map((variable, index) => (
            <div
              key={variable.id}
              onClick={() => setSelectedVariable(index)}
              className={`button_column_list ${index === selectedVariable ? "selected" : ""} p_3`}
            >
              <span>{variable.display}</span>
              <ButtonActionIcon type="delete" onClick={(e) => deleteVariable(e, index)} />
            </div>
          ))}
        </div>
        <div className="w_100 p_3" style={{ minWidth: "290px", height: "calc(100vh - 200px)" }}>
          {variables.length > 0 && (
            <CustomJS
              editorId={variables[selectedVariable].id}
              inputString={variables[selectedVariable].custom_js}
              handleChange={handleChangeInCustomJS}
              label="Custom JS"
              tableID={tableId}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DetailviewHeader;
export { DetailviewEditActions };
